import moment from 'moment';
import OrderSearchOptions from "../models/InventorySearchOptions";

const SEARCH_OPTIONS_SCHEMA: OrderSearchOptions = {
  startDate: moment(),
  endDate: moment(),
  startTime: moment(new Date(new Date().setHours(0, 0, 0, 0))),
  endTime: moment(new Date(new Date().setHours(23, 59, 0, 0))),
  keyword: '',
  currDate: false,
  errorKeyword: false
};

export {
  SEARCH_OPTIONS_SCHEMA
}